import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getError, LoadingState } from 'app/utils/callstate';
import { RuleQuery } from './rule.actions';
import * as fromRule from './rule.reducer';
import { RuleState } from './rule.reducer';
import * as _ from 'lodash';
import { AnalyticsSelectors } from 'app/main/analytics/selectors';
import { RuleEntry } from 'app/api/rule.api.service';

export const selectRuleState = createFeatureSelector<RuleState>('rule');

export const selectRule = createSelector(
    selectRuleState,
    fromRule.selectAll
);

export const selectCustomerRule = createSelector(
    selectRule,
    entries => _.filter(entries, { axis: 'cust' })
);

export const selectCustomerRuleSorted = createSelector(
    selectRule,
    entries => _.sortBy(_.filter(entries, { axis: 'cust' }), 'name')
);

export const selectProviderRule = createSelector(
    selectRule,
    entries => _.filter(entries, { axis: 'prov' })
);

export const selectProviderRuleSorted = createSelector(
    selectRule,
    entries => _.sortBy(_.filter(entries, { axis: 'prov' }), 'name')
);

export const selectRuleLoading = createSelector(
    selectRuleState,
    ruleState => ruleState.callState === LoadingState.Loading
);

export const selectRuleLoaded = createSelector(
    selectRuleState,
    ruleState => ruleState.callState === LoadingState.Loaded
);

export const selectRuleError = createSelector(
    selectRuleState,
    ruleState => getError(ruleState.callState)
);

export const selectRuleQuery = createSelector(
    selectRuleState,
    ruleState =>
        ({
            companyId: ruleState.companyId,
            key: ruleState.key,
            filter: ruleState.filter
        } as RuleQuery)
);

export const selectRuleCompanyId = createSelector(
    selectRuleState,
    ruleState => ruleState.companyId
);
